
import { ADS_MAKER_TYPE } from '../../../types/types'

class AdValidator {

  static getAccountErrors(item: any, pro: any, tickets: any[]) {
    const errors: any = {}
    if (!pro.admin && item.hasTicketing && tickets.length) {
      let hasPayment = false
      for (const ticket of tickets) {
        if (ticket.price > 0) {
          hasPayment = true
          break
        }
      }
      
      if (hasPayment && !pro.stripe_verified)
        errors.stripe_validation = 'Vous devez terminer la configuration des paiements dans le menu pour publier une annonce payante'
    }
    return errors
  }

  static getInfoErrors(item: any) {
    if (item.type === 'event')
      return this.getEventInfoErrors(item)
    if (item.type === 'discount')
      return this.getDiscountInfoErrors(item)
    return this.getPlaceInfoErrors(item)
  }

  static getTicketsErrors(item: any, pro: any, tickets: any[]) {
    const errors: any = {}
    if (item.type === 'discount' || !item.hasTicketing)
      return errors
    if (tickets.length === 0)
      errors.tickets = 'Vous devez ajouter au moins un ticket pour publier'
    else if (pro.type === ADS_MAKER_TYPE) {
      for (const ticket of tickets) {
        const price = Number(ticket.price || 0)
        if (price < 1 || ticket.isFree) {
          errors.tickets = 'Vous ne pouvez pas publier de ticket gratuit'
          break
        }
      }
    }
    return errors
  }

  static getEventInfoErrors(item: any) {
    const errors: any = {}
    // Picture check
    if (item.pictures && item.pictures.length === 0)
      errors.pictures = 'Vous devez ajouter une image pour publier'

    // Name check
    const name = item.name
    if (!this.wasRequired(name))
      errors.name = 'Veuillez saisir un nom'

    // Offer check
    const offer = item.offer
    if (!this.wasRequired(offer))
      errors.offer = 'Veuillez saisir une offre'
    
    // Description check
    const desc = item.description
    if (!this.wasMinimum(desc, 30))
      errors.description = 'La description est trop courte (30 min)'

    // Address check
    const address = item.address
    const postal_code = item.postal_code
    const city = item.city
    if (!this.wasRequired(address))
      errors.address = 'Ce champs est obligatoire'
    if (!this.wasRequired(postal_code))
      errors.postal_code = ' '
    if (!this.wasRequired(city))
      errors.city = ' '

    // Link check
    if (!item.hasTicketing) {
      const link = item.link || ''
      if (!this.wasRequired(link))
        errors.link = 'Veuillez renseigner une billeterie'
      else if (!this.isLink(link))
        errors.link = "L'URL entrée n'est pas valide"
    }

    // Date check
    const now = new Date().getTime()
    const dateStart = item.dateStart || new Date()
    if (!dateStart || dateStart.getTime() < now)
      errors.dateStart = "Date passée"

    const dateEnd = item.dateEnd || new Date()
    if (dateEnd.getTime() < dateStart.getTime())
      errors.dateEnd = "inférieur au début"

    return errors
  }

  static getDiscountInfoErrors(item: any) {
    const errors: any = {}

    // Picture check
    if (item.pictures && item.pictures.length === 0)
      errors.pictures = 'Vous devez ajouter une image pour publier'

    // Name check
    const name = item.name
    if (!this.wasRequired(name))
      errors.name = 'Veuillez saisir un nom'
    
    // Offer check
    const offer = item.offer
    if (!this.wasRequired(offer))
      errors.offer = 'Veuillez saisir une offre'
    
    // Link check
    const link = item.link || ''
    if (!this.wasRequired(link))
      errors.link = 'Veuillez renseigner un lien'
    else if (!this.isLink(link))
      errors.link = "L'URL entrée n'est pas valide"

    // Description check
    const desc = item.description
    if (!this.wasMinimum(desc, 30))
      errors.description = 'La description est trop courte (30 min)'
    
    return errors
  }


  static getPlaceInfoErrors(item: any) {

    const errors: any = {}

    // Picture check
    if (item.pictures && item.pictures.length === 0)
      errors.pictures = 'Vous devez ajouter une image pour publier'

    // Name check
    const name = item.name
    if (!this.wasRequired(name))
      errors.name = 'Veuillez saisir un nom'
    
    // Offer check
    const offer = item.offer
    if (!this.wasRequired(offer))
      errors.offer = 'Veuillez saisir une offre'
   
    // Address check
    const address = item.address
    const postal_code = item.postal_code
    const city = item.city
    if (!this.wasRequired(address))
      errors.address = 'Ce champs est obligatoire'
    if (!this.wasRequired(postal_code))
      errors.postal_code = ' '
    if (!this.wasRequired(city))
      errors.city = ' '

    // Link check
    if (!item.hasTicketing) {
      const link = item.link || ''
      if (!this.wasRequired(link))
        errors.link = 'Veuillez renseigner une billeterie'
      else if (!this.isLink(link))
        errors.link = "L'URL entrée n'est pas valide"
    }

    // Description check
    const desc = item.description
    if (!this.wasMinimum(desc, 30))
      errors.description = 'La description est trop courte (30 min)'
    
    return errors
  }
  
  static wasRequired(value: any) {
    return value && value.length > 0
  }
  static wasMinimum(value: any, min: number) {
    return this.wasRequired(value) && value.length >= min
  }
  static wasMaximum(value: any, max: number) {
    return !value || value.length <= max
  }
  static isLink(link: string) {
    return link.startsWith('https://') || link.startsWith('http://')
  }
}

export default AdValidator
